import React, { createRef, useEffect } from 'react'
import PropTypes from 'prop-types';
import { ButtomClose, FormBox, FormContent, FormFooter, FormHeader, FormSearch } from './styles'
import ItemSelect from '../ItemSelect';
import SearchBox from 'components/SearchBox';

const DialogFormSearch = ({ open, handleClose, title, textHolder, setTermSearch, resultList, renderItem, selectItem, classNameCss }) => {
  const refTop = createRef();
  const handleSelect = (item) => {
    selectItem(item);
    handleClose();
  }

  useEffect(() => {
    refTop.current.scrollTo(0, 0);
    return;
  }, [resultList, refTop])

  return (
    <FormSearch show={open}>
      <FormBox>
        <FormHeader>
          {title}
        </FormHeader>
        <SearchBox placeholder={textHolder} setTermSearch={setTermSearch} />
        <FormContent ref={refTop}>
          {resultList?.length > 0 ? (
            <>
              {resultList.map((item, index) => <ItemSelect key={index} handleSelect={() => { handleSelect(item); }}>{renderItem(item)}</ItemSelect>)}
            </>
          ) : (<>データなし</>)}
        </FormContent>
        <FormFooter>
          <ButtomClose onClick={() => { handleClose() }}>閉じる</ButtomClose>
        </FormFooter>
      </FormBox>
    </FormSearch>
  )
}

FormSearch.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
}

FormSearch.defaultProps = {
  title: '',
  name: '',
}

export default DialogFormSearch